import React from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import styles from "./adminverificationfailed.module.css";

function AdminVerificationFailed({ message }) {
    return (
        <div className={[styles.fail_container, "box-container"].join(" ")}>
            <div>
                <AiOutlineCloseCircle
                    color="#dc3545"
                    style={{ height: "100px", width: "100px" }}
                />
            </div>
            <div className={styles.fail_title}>
                <span>Email Verification Failed</span>
            </div>
            <div className={styles.fail_message}>
                <p>{message || "The verification link is invalid or has expired."}</p>
            </div>
        </div>
    );
}

export default AdminVerificationFailed; 